import { createContext } from 'react';
import { IPromoOffer } from '../../types/promoOffersSelection';

export const PromoOfferCardContext = createContext<IPromoOffer>({} as IPromoOffer);
